export default __webpack_public_path__ + "beta-maps-example-point-annotation-thumbnail-480-a3cf31277d26704e9eb2be681a3e7cfe.webp";